import { render, staticRenderFns } from "./a5.vue?vue&type=template&id=8c12ac52&scoped=true"
import script from "./a5.vue?vue&type=script&lang=js"
export * from "./a5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c12ac52",
  null
  
)

export default component.exports